"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./UserItem.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _HeaderItem = _interopRequireDefault(require("../../mixins/HeaderItem"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _UserIcon = _interopRequireDefault(require("./UserIcon"));

var _class, _class2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var UserItem = (_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(UserItem, _React$Component);

  var _super = _createSuper(UserItem);

  function UserItem() {
    _classCallCheck(this, UserItem);

    return _super.apply(this, arguments);
  }

  _createClass(UserItem, [{
    key: "getLabel",
    value: function getLabel(user, isImpersonating) {
      var helloText = "Hi, Member";

      if (isImpersonating) {
        helloText = "Impersonating " + user.email;
      } else if (user && user.firstName && user.lastName) {
        helloText = user.firstName + " " + user.lastName;
      }

      return helloText;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isImpersonating = _this$props.isImpersonating,
          user = _this$props.user,
          isSales = _this$props.isSales,
          isEmployer = _this$props.isEmployer;
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "user-item-button",
        onClick: this.handleClick
      }, /*#__PURE__*/_react.default.createElement(_UserIcon.default, {
        user: user,
        isImpersonating: isImpersonating,
        isSales: isSales,
        isEmployer: isEmployer
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "user-name-label no-mouseflow"
      }, this.getLabel(user, isImpersonating)), /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-down-open"
      }));
    }
  }]);

  return UserItem;
}(_react.default.Component), _defineProperty(_class2, "propTypes", {
  user: _propTypes.default.object.isRequired,
  isImpersonating: _propTypes.default.bool.isRequired,
  isSales: _propTypes.default.bool,
  isEmployer: _propTypes.default.bool
}), _class2), (_applyDecoratedDescriptor(_class.prototype, "getLabel", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "getLabel"), _class.prototype)), _class);

var _default = (0, _HeaderItem.default)(UserItem, "user-item");

exports.default = _default;